import http from '@/utils/http';

/**
 * 获取流量服务信息
 * @param {Vue} vm Vue实例
 * @param {string} activityOrderId 活动订单编号
 * @returns {Promise}
 */
export function getFlowServiceInfo(vm, activityOrderId) {
  const url = `/api/d1/activityOrderDataPurchaseRecord/newActivity/trafficStatistics`;
  const params = {
    activityOrderId: activityOrderId
  };
  
  return http.post(vm, url, params);
}

/**
 * 获取流量服务表格数据（分页）
 * @param {Vue} vm Vue实例
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getFlowServiceTableData(vm, params) {
  const url = `/api/d1/activityOrderDataPurchaseRecord/newActivity/page`;
  
  return http.post(vm, url, params);
}